import type { GetHashtags200PageAllOfThreeContentItem } from './getHashtags200PageAllOfThreeContentItem';

export type GetHashtags200PageAllOfThree = {
  content?: GetHashtags200PageAllOfThreeContentItem[];
};
